export default __webpack_public_path__ + "306a822b55ff110169ce4abd041520bb.png";